import React, { useEffect, useState } from 'react';
import Menu from "../Header/Menu";
import {
    CssBaseline,
    makeStyles,
} from "@material-ui/core";
import { DataGrid } from '@material-ui/data-grid';
import {getLogs} from "../httpUtils";

const columns = [
    {
        field: 'when',
        headerName: 'date',
        type: 'date',
        width: 200,
        valueFormatter: (params) => {
            return new Date(params.value).toLocaleString()
        },
    },
    {
        field: 'tag',
        headerName: 'tag',
        width: 150,
    },
    {
        field: 'user',
        headerName: 'user',
        width: 200,
        valueGetter: (params) => {
            console.log(params.data)
            return params.data.hasOwnProperty('initiator') ? `@${params.data.initiator.user}` : undefined
        }
    },
    {
        field: 'ip',
        headerName: 'ip',
        width: 150,
        valueGetter: (params) => {
            return params.data.hasOwnProperty('initiator') ? `${params.data.initiator.ip}` : undefined
        }
    },
    {
        field: 'message',
        headerName: 'message',
        width: 1000
    }
];

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexFlow: "column",
        height: "100vh"
    },
    container: {
        display: "flex",
        flex: 1,
        margin: theme.spacing(2),
    }
}));

export default function JournalCRM() {
    const classes = useStyles();
    const [list, setList] = useState([]);

    function initPage() {
        getLogs().then((r)=>{
            setList(r)
        })
    }

    useEffect(()=>{
        initPage();
    }, [])

    return (
        <React.Fragment>
            <div className={classes.root}>
                <Menu title='Журнал действий CRM' reloadData={()=>{
                    initPage();
                }}/>
                <CssBaseline />
                <div className={classes.container}>
                    <DataGrid
                        rows={list}
                        columns={columns}
                        // autoHeight
                        // pageSize={10}
                        autoPageSize
                        disableSelectionOnClick
                    />
                </div>
            </div>
        </React.Fragment>
    )
}
